import React,{Component} from 'react'
function Square(props) {
  return (
    <button className="square" id="er" onClick={props.onClick}>
      {props.value}
    </button>
  );
}
export default Square
